import { components, MenuListProps } from 'react-select';

export const DropdownMenuList =
  (showNoOptionsMessage = false, showLoadingMessage = false) =>
  ({ children, ...props }: MenuListProps) => {
    if (!showLoadingMessage && props['isLoading']) {
      return null;
    }

    if (!showNoOptionsMessage && Array.isArray(children) && !children?.length) {
      return null;
    }

    if (props.selectProps.isSearchable && !props.options.length) {
      return null;
    }

    return (
      <div data-testid="menuList">
        <components.MenuList className="stihl-text-body-sm-reg" {...props}>
          {children}
        </components.MenuList>
      </div>
    );
  };
